module.exports = __webpack_public_path__ + "static/media/AU 2017 Research Roster.2ff1b3b6.xlsx";